// material-ui
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

// project import
import DrawerHeaderStyled from './DrawerHeaderStyled';
import Logo from 'components/logo';
import { DRAWER_TRANSITION_DURATION, DRAWER_TRANSITION_EASING } from '../MiniDrawerStyled';

// ==============================|| DRAWER HEADER ||============================== //

interface Props {
  open: boolean;
}

// Both logos stay MOUNTED and crossfade. The old instant swap unmounted the
// wide logo the moment `open` flipped — while the drawer was still 288px wide
// — so the header showed nothing for the length of the animation, which read
// as "the logo sometimes disappears".
const DrawerHeader = ({ open }: Props) => {
  const theme = useTheme();
  const t = (props: string) => `${props} ${DRAWER_TRANSITION_DURATION}ms ${DRAWER_TRANSITION_EASING}`;

  return (
    <DrawerHeaderStyled theme={theme} open={open}>
      <Box sx={{ position: 'relative', width: '100%', height: 40, display: 'flex', alignItems: 'center' }}>
        {/* Full wordmark: anchored left, fades + slides out on collapse. */}
        <Box
          sx={{
            position: 'absolute',
            left: 0,
            display: 'flex',
            alignItems: 'center',
            opacity: open ? 1 : 0,
            transform: open ? 'translateX(0)' : 'translateX(-8px)',
            transition: `${t('opacity')}, ${t('transform')}`,
            pointerEvents: open ? 'auto' : 'none'
          }}
        >
          <Logo sx={{ width: 'auto' }} />
        </Box>
        {/* Icon mark: centered in the rail, fades + scales in on collapse. */}
        <Box
          sx={{
            position: 'absolute',
            left: '50%',
            display: 'flex',
            alignItems: 'center',
            opacity: open ? 0 : 1,
            transform: `translateX(-50%) scale(${open ? 0.7 : 1})`,
            transition: `${t('opacity')}, ${t('transform')}`,
            pointerEvents: open ? 'none' : 'auto'
          }}
        >
          <Logo isIcon sx={{ width: 35 }} />
        </Box>
      </Box>
    </DrawerHeaderStyled>
  );
};

export default DrawerHeader;
